var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99964 8.72736C9.43726 8.72736 11.4133 6.77368 11.4133 4.36368C11.4133 1.95369 9.43726 0 6.99964 0C4.56202 0 2.58594 1.95369 2.58594 4.36368C2.58594 6.77368 4.56202 8.72736 6.99964 8.72736Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1086 16H0.89144C0.764344 16.0011 0.638476 15.9795 0.522443 15.9368C0.40641 15.8941 0.302948 15.8313 0.219132 15.7527C0.135316 15.6741 0.0731228 15.5816 0.0368044 15.4814C0.000486005 15.3811 -0.0091007 15.2757 0.00869979 15.1721C0.248563 13.7873 1.08773 12.5201 2.37206 11.6033C3.6564 10.6866 5.29965 10.1819 7 10.1819C8.70035 10.1819 10.3436 10.6866 11.6279 11.6033C12.9123 12.5201 13.7514 13.7873 13.9913 15.1721C14.0091 15.2757 13.9995 15.3811 13.9632 15.4814C13.9269 15.5816 13.8647 15.6741 13.7809 15.7527C13.6971 15.8313 13.5936 15.8941 13.4776 15.9368C13.3615 15.9795 13.2357 16.0011 13.1086 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.13b9afb847f7af9077f50549e3ecd84f.svg";
export { ForwardRef as ReactComponent };